import React from 'react';

import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { mobileLayoutComponent } from '../new-event-layouts/shared/mobileLayoutComponent';

import { Row, Col } from 'react-bootstrap';
import cn from 'classnames';
import Logo from '../event_components/logo';
import CheckoutController from '../event_components/Checkout';
import Title from '../event_components/title';
import Location from '../event_components/location';
import Time from '../event_components/time';
import Details from '../event_components/details';
import AttendButton from '../event_components/attend_button';
import styles from './list.scss';

import StackMobileLayout from './mobile-stack';
import MinimalLayout from './mobile-minimal';
import SideBySideMobileLayout from './mobile-side-by-side';
import GoogleLocation from '../event_components/google_location';
import EventStatus from '../event_components/event_status';
import TicketPurchasing from '../event_components/ticket-purchasing';
import AddEventToCalendar from '../event_components/add_to_calendar';
import { LocaleWrapper } from '../../locale-wrapper';
import Host from '../event_components/host';
import TwitchPreviousVideo from '../event_components/twitch-video';
import PaddedComponent from './top_padder';
import { attendButtonIsVisible } from './utils';
import PaginationContainer from './pagination_container';

const propTypes = {
  event: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
};

export class ListEvent extends React.Component {
  constructor() {
    super();
    this.state = {
      openTicketing: false,
    };
  }
  toggleAttendButton = () => {
    const { event, onEventRegister } = this.props;

    if (event.get('type') === 'google') {
      return;
    }
    this.props.onResizeComponent();
    this.setState(
      {
        openTicketing: onEventRegister ? false : !this.state.openTicketing,
      },
      () => this.props.onResizeComponent()
    );
    onEventRegister && onEventRegister(event);
  };
  render() {
    const { event, settings, onResizeComponent, forceButtonNewRow } = this.props;
    const logo = event.getIn(['logo', 'url']);

    const hasLogo = settings.get('showEventLogo');
    if (event.get('initial_embed') || event.get('is_offline')) {
      return event.get('is_offline') ? (
        <TwitchPreviousVideo settings={settings} event={event} />
      ) : (
        <TicketPurchasing event={event} settings={settings} open onResizeComponent={onResizeComponent} />
      );
    }

    const showLogo = logo && hasLogo && event.get('type') !== 'google' && event.get('type') !== 'zoom';
    const COLUMN_WIDTHS = {
      xs: {
        logo: 6,
        details: 6,
        button: 12,
      },
      sm: {
        logo: 5,
        details: 7,
        button: 12,
      },
      md: {
        logo: 3,
        details: 9,
        button: 3,
      },
    };

    const xsLogoVisible = showLogo;
    const xsDetailsColumns = xsLogoVisible ? 6 : 12;
    const smDetailsColumns = xsLogoVisible ? COLUMN_WIDTHS.sm.details : 12;
    const mdDetailsColumnsWithLogo = !forceButtonNewRow && attendButtonIsVisible(event, settings) ? 6 : 9;
    const mdDetailsColumnsWithoutLogo = !forceButtonNewRow && attendButtonIsVisible(event, settings) ? 9 : 12;
    const mdDetailsColumns = showLogo ? mdDetailsColumnsWithLogo : mdDetailsColumnsWithoutLogo;

    return (
      <div className={`${styles.container} ${forceButtonNewRow ? styles.center : ''}`}>
        <CheckoutController
          variant="default"
          event={event}
          settings={settings}
          inClassName="checkout-fade"
          openTicketing={this.state.openTicketing}
          onResizeComponent={onResizeComponent}
          onClose={() => {
            this.setState({
              openTicketing: false,
            });
          }}
        >
          <Row className={cn(styles.list, 'event')}>
            {xsLogoVisible && (
              <Col xs={6} sm={COLUMN_WIDTHS.sm.logo} md={COLUMN_WIDTHS.md.logo}>
                <Logo event={event} settings={settings} className={styles.listPhoto} />
              </Col>
            )}

            {event.get('type') === 'zoom' && (
              <Col xs={6} md={4} className={styles.zoomColumn}>
                <Host event={event} settings={settings} />
              </Col>
            )}

            <Col xs={xsDetailsColumns} sm={smDetailsColumns} md={mdDetailsColumns} className={styles.details}>
              <Row middle="xs">
                <Col xs={12} sm={!event.get('venue') && event.get('venue').isEmpty() ? 3 : 12}>
                  <Title event={event} settings={settings} />
                  <PaddedComponent>
                    <Time event={event} settings={settings} className={`${styles.time} ${forceButtonNewRow ? styles.center : ''}`} withIcon />
                  </PaddedComponent>
                  {(settings.get('showVenue') || settings.get('showFullAddress')) && (
                    <Col xs={9}>
                      {event.get('type') === 'google' ? (
                        <GoogleLocation event={event} />
                      ) : (
                        <Location event={event} className={styles.location} withIcon settings={settings} />
                      )}
                    </Col>
                  )}
                  {settings.get('showEventStatus') && <EventStatus event={event} settings={settings} />}
                  {settings.get('enableAddToCalendar') && <AddEventToCalendar event={event} settings={settings} className={styles.addToCalendar} />}
                </Col>
              </Row>
              <Details event={event} settings={settings} className={styles.description} onResizeComponent={onResizeComponent} />
            </Col>

            {attendButtonIsVisible(event, settings) && (
              <Col
                className={cn(styles.buttonContainer, { [styles.buttonRow]: forceButtonNewRow })}
                xs={forceButtonNewRow ? 12 : COLUMN_WIDTHS.xs.button}
                sm={forceButtonNewRow ? 12 : COLUMN_WIDTHS.sm.button}
                md={forceButtonNewRow ? 12 : COLUMN_WIDTHS.md.button}
              >
                <AttendButton event={event} settings={settings} handleButtonClick={this.toggleAttendButton} />
              </Col>
            )}
          </Row>
        </CheckoutController>
      </div>
    );
  }
}

ListEvent.propTypes = propTypes;

const oldMobileLayoutComponent = (settings) => {
  const layoutDesign = settings.get('mobileLayoutDesign');

  const mapping = {
    stack: StackMobileLayout,
    sideBySide: SideBySideMobileLayout,
    minimal: MinimalLayout,
  };
  return mapping[layoutDesign] || mobileLayoutComponent(settings) || StackMobileLayout;
};

function ListContainer({ events, settings, isMobile, onResizeComponent, onEventRegister, forceButtonNewRow }) {
  const Component = isMobile ? oldMobileLayoutComponent(settings) : ListEvent;

  const renderEvent = (event) => (
    <LocaleWrapper event={event}>
      <Component
        key={event.get('id')}
        event={event}
        settings={settings}
        onResizeComponent={onResizeComponent}
        onEventRegister={onEventRegister}
        forceButtonNewRow={forceButtonNewRow}
      />
    </LocaleWrapper>
  );

  return <PaginationContainer events={events} settings={settings} onResizeComponent={onResizeComponent} renderEvent={renderEvent} />;
}

ListContainer.propTypes = {
  events: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
  isMobile: PropTypes.bool,
};

export default ListContainer;
